import { render } from "./InterestPanel.vue?vue&type=template&id=62b86dd6&scoped=true"
import script from "./InterestPanel.vue?vue&type=script&lang=js"
export * from "./InterestPanel.vue?vue&type=script&lang=js"

import "./InterestPanel.vue?vue&type=style&index=0&id=62b86dd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b86dd6"]])

export default __exports__